import * as React from "react";
const NewsDown3 = (props) => (
  <svg
    width={15}
    height={9}
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.59614 7.40596L13.885 1.20327C14.1442 0.947585 14.5597 0.952413 14.8131 1.21405C15.0664 1.47569 15.0616 1.89507 14.8024 2.15075L8.0492 8.81143C7.79194 9.06517 7.38025 9.06263 7.12609 8.80573L0.191894 1.79718C-0.0642248 1.53832 -0.0639264 1.11892 0.192561 0.860422C0.449048 0.601928 0.864597 0.602229 1.12072 0.861095L7.59614 7.40596Z"
      fill="#184548"
    />
  </svg>
);
export default NewsDown3;
